export default {
  // 微信登录
  async wxLogin(params) {
    let actiontype = "AccountService_WeChatLoginHandler";
    return await this.fetch(actiontype, params);
  },
  // 支付宝登录
  async aliLogin(params) {
    let actiontype = "AccountService_AlipayLoginHandler";
    return await this.fetch(actiontype, params);
  },
  //获取banner图
  async getBannerList(params) {
    let actiontype = "getBannerListForPage";
    return await this.fetch(actiontype, params);
  },
  // 升舱的特殊微信登录
  async spWxLogin(params) {
    let actiontype = "AccountService_newUpcabinWeChatLoginHandler";
    return await this.fetch(actiontype, params);
  },
  // 创建订单   中转节点
  async flightOrderCreate(params) {
    let actiontype = "OrderCreateService_CreateOrderV1";
    return await this.fetch(actiontype, params);
  },
  async getAvailableCouponList(params) {
    let actiontype = "CouponService_getAvailableCouponList";
    return await this.fetch(actiontype, params);
  },
  // 判断是否登录  
  async checkLogin(params) {
    let actiontype = 'ischeckLogin';
    return await this.fetch(actiontype, params)
  },
  // 校验活动是否在开始时间，是否在白名单 白名单后台校验
  async checkModelPermission(params) {
    let actiontype = 'checkModelPermission';
    return await this.fetch(actiontype, params)
  },
};



// WEBPACK FOOTER //
// ./src/interfaces/modules/common.js